<template>
  <element>
    <nav-breadcrumb :menu="[{label: '客户管理  '}, {label: '已授信客户 '}, {label: '客户详情 '}]"/>
    <el-row>
      <el-col class="grid-content bg-purple">
        <el-tabs v-model="tabName">
          <template>
            <el-tab-pane label="客户信息" name="CustomerSummary">
              <panel label="基本信息">
                <form-build
                  :form-data="customerDetail"
                  :form-rules="dataFormRules"
                  :form-columns="customerColumns"
                  class="formTable"
                />
              </panel>
              <panel label="证件图片" class="zhengjianxinxi">
                <photo-browser v-model="customerDetail.c__customerICFront" type='image' label="本人身份证正面"/>
                <photo-browser v-model="customerDetail.c__customerICBack" type='image' label="本人身份证反面"/>
                <photo-browser v-model="customerDetail.c__customerHukou1" type='image' label="本人户口本主页"/>
                <photo-browser v-model="customerDetail.c__customerHukou2" type='image' label="本人户口本"/>
              </panel>
            </el-tab-pane>
            <el-tab-pane label="银行账户" name="bank">
              <data-table
                :table-data="{data:customerDetail.accounts.filter(item=>item.cb__accountId)}"
                :columns="BankColumns"
                :actions="actions"
                :is-pagination-show="false"
              />
            </el-tab-pane>
          </template>
        </el-tabs>
      </el-col>
    </el-row>
  </element>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
    export default {
        name: "CustomerView",
      data(){
          return{
            tabName: 'CustomerSummary',
            customerDetail:{
              accounts:[]
            },
            actions: [],
            dataFormRules:{},
            customerColumns:[
              {
                label: '身份证号码',
                field: 'c__customerIC',
              },
              {
                label: '客户姓名',
                field: 'c__customerName',
              },
              {
                label: '性别',
                field: 'c__customerSex',
                formatter: function (c,v) {
                  return Status2CN('Sex_'+v)
                }
              },


              {
                label: '手机号',
                field: 'c__customerContactNo',

              },
              {
                label: '出生日期',
                field: 'c__customerDOB',

              },

              {
                label: '户口地区',
                field: 'c__customerHukou',
              },

              {
                label: '籍贯',
                field: 'c__customerJiguan',
                span:24
              },
              {
                label: '详细地址',
                field: 'c__customerAddress',
                span:24
              },

              {
                label: '婚姻状况',
                field: 'c__customerMartialStatus',
              },
            ],
            BankColumns: [
              {
                label: '账号',
                field: 'cb__accountNo'
              },

              {
                label: '户名',
                field: 'cb__accountName'
              },
              {
                label: '开户银行',
                field: 'cb__bank'
              },
              {
                label: '创建时间',
                field: 'cb__createdDate',
                formatter: function (r,c,v) {
                  return moment(v).format('YYYY-MM-DD HH:mm:ss')
                }
              },
            ],
          }
      },
      mounted() {
        this.getData()
      },
      methods: {
        getData : function () {
          xhr.getFangCustomer({
            'c.customerId': this.$route.query['customerId']
          }, res=>{
            try{
              if(res.data.status == 'success') {
                this.customerDetail = res.data.data
              }
            }catch(e){}
          })
        },
      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/CustomerView.vue